import {
    SalesChannel,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_YOUNG,
} from '@vfde-fe/sails-constants';
import { getIsTradeInEligibleFromDom } from './domHelper';

/**
 * Check if trade in can be selected for this device/saleschannel
 * @param salesChannel
 */
export function getIsTradeInEligible (salesChannel: SalesChannel) {
    return [SALESCHANNEL_CONSUMER].indexOf(salesChannel) !== -1 && getIsTradeInEligibleFromDom() || getIsTradeInEligibleFromPageOptions();
}

/**
 * Check if trade in can be selected based on additional page options
 */
export function getIsTradeInEligibleFromPageOptions () {
    return (window as any).additionalPageOptions?.promos?.tradeIn !== undefined;
}
